import topic from '../topic';
export const cpttAPI = {
  getAllCpttsV2: topic.cpttTopic + '/get_all_cptts_v2'
};
